<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Настройки курьерского сервиса</strong>
                </CCardHeader>

                <CCardBody>
                    <div class="overflow-hidden border border-gray-300 rounded-md">
                        <div class="flex items-center bg-gray-100">
                            <div class="w-2/5 py-2 font-bold pl-2">Настройки</div>
                            <div class="w-3/5 py-2 font-bold pl-2">Описание</div>
                        </div>
                        <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                            <div class="w-2/5 pl-2">
                                <span class="text-purple-700 cursor-pointer hover:underline" @click="$router.push(`/courier-service/start-towers`)">
                                    Начало работы (башни)
                                </span>
                            </div>
                            <div class="w-3/5 pl-2">
                                <span class="">
                                    Какаие башни предлагать при начале работы или выходе с перерыва...
                                </span>
                            </div>
                        </div>
                        <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                            <div class="w-2/5 pl-2">
                                <span class="text-purple-700 cursor-pointer hover:underline" @click="$router.push(`/courier-service/courier-queue`)">
                                    Список курьеров
                                </span>
                            </div>
                            <div class="w-3/5 pl-2">
                                <span class="">
                                    Настройки списка курьеров в заказе...
                                </span>
                            </div>
                        </div>
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    export default {
        name: 'CourierService'
    }
</script>
<style scoped lang="scss">
    .disabled {
        color: #8a93a2;
        &:hover {
            text-decoration: none;
            cursor: inherit;
        }
    }
</style>
